import { render, staticRenderFns } from "./RecommendUserForProjectsQuickInfoLayer.vue?vue&type=template&id=5fbdf049&scoped=true"
import script from "./RecommendUserForProjectsQuickInfoLayer.vue?vue&type=script&lang=ts"
export * from "./RecommendUserForProjectsQuickInfoLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbdf049",
  null
  
)

export default component.exports